/**
 * 쿠키 스코프에는 포트가 포함되지 않는다(same-host 정책).
 * 따라서 관리자(localhost:3000)와 클라이언트(localhost:8000)가 같은 쿠키 이름을 쓰면
 * 같은 저장소를 공유해 서로의 세션 토큰을 덮어쓴다.
 * 앱 전용 접두사를 붙여 분리한다.
 */
const TOKEN = {
	ACCESS: 'np_client_accessToken',
	REFRESH: 'np_client_refreshToken',
};

export default TOKEN;
